
import { useState } from 'react';
import { DashboardLayout } from '@/components/layouts/DashboardLayout';
import { NotificationList } from '@/features/notifications/components/NotificationList';
import { NotificationFilters } from '@/features/notifications/components/NotificationFilters';
import { Separator } from '@/components/ui/separator';
import { useNotifications } from '@/features/notifications/hooks/useNotifications';
import { motion } from 'framer-motion';

export default function Notifications() {
  const [filter, setFilter] = useState<'all' | 'unread' | 'read'>('all');
  const { notifications, markAsRead, markAllAsRead, loading } = useNotifications();

  const filteredNotifications = notifications.filter(notification => {
    if (filter === 'read') return notification.read;
    if (filter === 'unread') return !notification.read;
    return true;
  });

  return (
    <DashboardLayout>
      <motion.div
        className="space-y-6"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3 }}
      >
        <div className="flex items-center justify-between">
          <motion.h1
            className="text-3xl font-semibold"
            initial={{ opacity: 0, y: -10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.1 }}
          >
            Notifications
          </motion.h1>
        </div>
        
        <Separator />
        
        <NotificationFilters 
          filter={filter} 
          setFilter={setFilter} 
          onMarkAllAsRead={markAllAsRead} 
          unreadCount={notifications.filter(n => !n.read).length}
        />
        
        <NotificationList 
          notifications={filteredNotifications} 
          onMarkAsRead={markAsRead}
          loading={loading}
        />
      </motion.div>
    </DashboardLayout>
  );
}
